import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setCurrentCourse, setCurrentPage, setSidebarRouteData } from "../../../store/actions/mainActions";
import EventSession from "../../content/Events/Event/EventSession";
import eventsService from "../../../Axios/services/events.service";
import "./CoursePage.scss";

const CoursePage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [course, setCourse] = useState<any>(undefined);

  useEffect(() => {
    getCourse();

    dispatch(setCurrentPage("coursePage"));
    dispatch(setSidebarRouteData({ id }));
    return () => {
      dispatch(setSidebarRouteData({}));
      dispatch(setCurrentPage(""));
    };
  }, []);

  const getCourse = async () => {
    const course = await eventsService.getCourse(id);
    if (course) {
      setCourse(course);
      dispatch(setCurrentCourse(course));
    }
    return () => {
      dispatch(setCurrentCourse(null));
    };
  };

  return course ? (
    <div className="course-page container-fluid">
      <div className="ctitle mb-md-4  mb-2">{course.eventName}</div>
      <div className="cbrief mb-md-5 mb-3">{course.description}</div>
      <div className="ctimeline mb-2">Course Timeline</div>
      <div className="cbrief mb-md-5 mb-3">An annual ten-day study program at the Shalom Hartman Institute in Jerusalem</div>
      <div className="">
        {course.sessions && Array.isArray(course.sessions)
          ? course.sessions.map((session: any, i: number) => {
              return <EventSession id={session._id} key={i} isFeed={false} session={session} communities={course.communities} />;
            })
          : null}
      </div>
    </div>
  ) : (
    <div>{"Loading..."}</div>
  );
};

export default CoursePage;
